import React, { memo, useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useResolvedPath,
  useMatch,
  NavLink,
  useLocation,
  matchPath,
  useNavigate,
} from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { KioskDashboardActions } from "../../_store/KioskDashboard.slice.js";
import useKioskRestrictIntervalValidation from "../../hooks/useKioskRestrictIntervalValidation.jsx";
import TranslateFile from "../../Loc/TranslateFile.jsx";
import { authActions } from "../../_store/auth.slice.js";
import { showAlert } from "../common/showAlert.jsx";
import { getStoredValue, setStoredValue } from "../../_helpers/storageHelper.js";

function NavItem({ menu, allmenus, ...props }) {
  // Ensure menu and menu.URLPath exist before proceeding

  const context = useContext(AppSettings);

  let resolved = useResolvedPath(menu.path);
  let match = useMatch({ path: resolved.pathname });

  let location = useLocation();
  let match2 = matchPath({ path: menu.path, end: false }, location.pathname);


  let icon = menu.icon && (
    <div className="menu-icon">
      <i className={menu.icon}></i>
    </div>
  );
  let img = menu.img && (
    <div className="menu-icon-img">
      <img src={menu.img} alt="" />
    </div>
  );
  let caret = menu.children && !menu.badge && (
    <div className="menu-caret"></div>
  );
  let label = menu.label && (
    <span className="menu-label ms-5px">{menu.label}</span>
  );
  let badge = (menu.badge !== 0) && <div className="menu-badge">{menu.badge}</div>;
  let highlight = menu.highlight && (
    <i className="fa fa-paper-plane text-theme"></i>
  );
  let title = menu.title && (
    <div className="menu-text">
      {menu.title} {label} {highlight}
    </div>
  );

  const storedloginResponse = getStoredValue("loginResponse");
  const storedLoginDetails = getStoredValue("loginDetails");

  const navigate = useNavigate();
  // const validateKioskRestrictInterval = useKioskRestrictIntervalValidation();
  const dispatch = useDispatch();
  const pageReload = useSelector((x) => x?.auth?.isPageReload);

  const handleInmateInbox = async (e,path, menuName, allmenus) => {
    const podCode = storedLoginDetails?.PodCode;
    const inmateID = storedloginResponse?.InmateID;
    // validateKioskRestrictInterval(storedLoginDetails)
    if (path == window.location.pathname) {
      const pageReloading = pageReload + 1;
      dispatch(authActions?.updateLocation(pageReloading));
    }

    if (inmateID && podCode) {
      await dispatch(KioskDashboardActions.getLoadInmateMainMenu({ inmateID, podCode })).then(x => {
        if (x?.payload?.length > 0) {
          let menuAcess = x?.payload?.filter((x) => x.MenuName === menuName);
          if (menuAcess?.length == 0) {
            let firstmenu = x?.payload[0];
            let nestmenu = allmenus?.filter((x) => x.title === firstmenu?.MenuName);
            showAlert(null, "Access Denied", `You don't have access to the menu: ${menuName}`, "error",);
            navigate(nestmenu[0]?.path);
            return;
          }
          else {
            navigate(path);
            context.toggleAppSidebarMobile(e);
          }
        }
      });
    }
    else {
      navigate(path);
      context.toggleAppSidebarMobile(e);
    }

  }

  return (
    <div
      className={
        "menu-item" +
        (match || match2 ? " active" : "") +
        (menu.children ? " has-sub" : "")
      }
    >
      <NavLink
        className="menu-link fs-5"
        to={menu.path}
        {...props}
        title={menu.title}
        onClick={(e) => { handleInmateInbox(e,menu.path, menu?.menuName, allmenus) }}
      >
        {img} {icon} {title}
        {caret} {badge}
      </NavLink>

      {menu.children && (
        <div className="menu-submenu">
          {menu.children.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

// SidebarNav Component
function SidebarNav() {
  const context = useContext(AppSettings);
  const { LoadInmateMainMenuDetails } = useSelector((state) => state.KioskDashboard);
  const menu = getStoredValue("inmateMenuList");
  const currentLang = TranslateFile();


  const inmateMenuList = useMemo(() => {
    if (LoadInmateMainMenuDetails?.length > 0)
      setStoredValue("inmateMenuList", LoadInmateMainMenuDetails);
    return LoadInmateMainMenuDetails?.length > 0
      ? LoadInmateMainMenuDetails
      : getStoredValue("inmateMenuList");
  }, [LoadInmateMainMenuDetails, menu]);

  // Function to map menu name to an icon
  const getIcon = (menuName) => {
    const iconMap = {
      Messages: "fa-solid fa-envelope",
      Photos: "fa-solid fa-image",
      Requests: "fa-solid fa-user-plus",
      Documents: "fa-solid fa-file-text",
      "Postal Mails": "fa-solid fa-newspaper",
      "My Contacts": "fa-solid fa-address-card",
      "Law Library": "fa-solid fa-balance-scale",
      "My Invites": "fa-solid fa-users",
      "Place Order": "fa-solid fa-shopping-cart",
      "My Profile": "fa-solid fa-user",
      "E-Cards": "fa-solid fa-id-card",
      "Visitation": "fa fa-video-camera",
    };
    return iconMap[menuName] || ""; // Default to empty string if not found
  };
  const getTitle = (menuName) => {
    const titleMap = {
      Messages: currentLang?.MenuHeaders?.Messages,
      Photos: currentLang?.MenuHeaders?.Photos,
      Requests: currentLang?.MenuHeaders?.Requests,
      Documents: currentLang?.MenuHeaders?.Documents,
      "Postal Mails": currentLang?.MenuHeaders?.Postal_Mails,
      "My Contacts": currentLang?.MenuHeaders?.My_Contacts,
      "Law Library": currentLang?.MenuHeaders?.Law_Library,
      "My Invites": currentLang?.MenuHeaders?.My_Invites,
      "Place Order": currentLang?.MenuHeaders?.Place_Order,
      "My Profile": currentLang?.MenuHeaders?.My_Profile,
      "E-Cards": currentLang?.MenuHeaders?.E_Card,
    };
    return titleMap[menuName] || menuName; // Default to empty string if not found
  };

  // Memoize menu mapping
  const Menu = useMemo(() => {
    return inmateMenuList?.map((item) => {
      const menuPaths = item.NewMenuRedirectPath || item.AppMenuRedirectPath;
      return {
        path: menuPaths
          .replace("../Kiosk.v1/", "/")
          .replace(".aspx", ""), // Adjust path format
        icon: getIcon(item.MenuName), // Assign correct icons
        title: getTitle(item.MenuName),
        menuName: item.MenuName,
        badge: item?.UnReadCount,
      };
    });
  }, [inmateMenuList]);

  return (
    <div className="menu inmate-menu-list">
      {Menu && Menu?.map((menu, i) => <NavItem key={i} menu={menu} allmenus={Menu} />)}
    </div>
  );
}

export default memo(SidebarNav);
